import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/api/apiClient';
import { CACHE_TIME_5_MINUTES } from '@/shared/config';
import type { Language } from '@/shared/types';

export interface InvoiceParam {
  paramId: string;
  paramName: string;
  paramValue: string;
  isVisible: boolean;
}

export interface UseInvoiceParams {
  invoiceId: string;
  lang?: Language;
  enabled?: boolean;
}

export function useInvoice({
  invoiceId,
  lang,
  enabled = true,
}: UseInvoiceParams) {
  return useQuery({
    queryKey: ['invoice', invoiceId, lang],
    queryFn: async (): Promise<InvoiceParam[]> => {
      const response = await apiClient.get(
        `/operations/bank/deposit/invoices/${invoiceId}`,
        { params: lang ? { lang } : undefined }
      );

      return response.data as InvoiceParam[];
    },
    enabled: enabled && !!invoiceId,
    staleTime: CACHE_TIME_5_MINUTES,
    retry: 2,
  });
}
